import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installWebApi } from './platform/web-api';
import './css/styles.css';
import '@arcgis/core/assets/esri/themes/dark/main.css';

// In Electron the preload populates window.api before the renderer runs.
// Without it (= we're served from the dev server in a browser), install the
// fetch+WebSocket shim that mirrors the same Api shape.
installWebApi();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
